const stripe = Stripe("pk_test_xJNOSLhqbq9O63S6TajlCZ1t00kz2FZAvE");
import { getFunctions, httpsCallable } from "firebase/functions";
const functions = getFunctions();
const createPaymentIntent = httpsCallable(functions, "createPaymentIntent");


const orderValue = { value: 1499};

let elements;
let clientSecret;

initialize();

function initialize() {

    
    createPaymentIntent({ chargeableAmount: orderValue, product_ID: "123456" }).then((result) => {
            console.log("objectReturnedFromFunction", result);
            console.log("objectReturnedFromFunction value", result.data.messageReceived);
            console.log("objectReturnedFromFunction value", result.data.clientSecret);
            clientSecret = result.data.clientSecret;

            // console.log("font", myFont.toString());

            const appearance = {
                theme: 'stripe',           
            };

            elements = stripe.elements({ 
                appearance,
                clientSecret,
                // fonts: [{
                //     family: "myFont",
                //     src: `url("${myFont.toString()}")`,
                //     weight: 500
                // }]
            });
        
            const paymentElementOptions = {
                paymentMethodOrder: ['apple_pay', 'google_pay', 'paypal'],
                // buttonType: {
                //     applePay: 'buy',
                //     googlePay: 'buy',
                //     paypal: 'buynow'
                // }
                buttonHeight: 50,
                buttonTheme: {
                  applePay: 'white-outline'
                }
            };

        
            const paymentElement = elements.create("expressCheckout", paymentElementOptions);
            paymentElement.mount("#payment-element");

            // Create and mount the Address Element in shipping mode
            const addressElement = elements.create("address", {
                mode: "shipping",
            });
            addressElement.mount("#address-element");

    });


    
}
